module.exports = __webpack_public_path__ + "static/media/logo.e641cb8c.svg";